/**
 * @param path 接口路径
 * @param method 接口类型默认get，get、post、put
 * @param isFormData 默认false, 表单格式true，false为json格式
 * @param server 默认是hlw（zwww 政务网需要)
 */

module.exports = {
    common: {
        fileUpload: {
            path: '/common/fileUpload',
            method: 'POST',
            isFormData: true,
            isGetToken: true
        },
        // token
        getThirdToken: {
            path: '/oauth2/token',
            method: 'POST',
            isFormData: true,
        },
        // 查询事项基本信息
        getBasicInfo: {
            path: '/sds/taskCenter/getBasicInfo/v1',
            method: 'POST',
            isGetToken: true
        },
        // 获取iframe地址
        getCityFormUrl: {
            path: '/sds/jssform/getCityFormUrl',
            method: 'POST',
            isFormData: true,
            isGetToken: true,
        },
        getPageData: {
            path: '/sds/zwztformrest/getPageData',
            method: 'POST',
            isFormData: true,
            isGetToken: true
        },
        // 材料上传
        pushFileInfo: {
            path: '/sds/onethingCenter/pushFileInfo/v1',
            method: 'POST',
            isGetToken: true,
        },
        //  数据
        getThemeInfoAll: {
            path: '/sds/onethingCenter/getThemeInfoAll/v1',
            method: 'POST',
            isGetToken: true
        },
        // 一件事办件申报接口
        pushApplyInfo: {
            path: '/sds/onethingCenter/pushApplyInfo/v1',
            method: 'POST',
            isGetToken: true,
        },
        // 共享材料
        getThemeShareMaterialList: {
            path: '/sds/onethingCenter/getThemeShareMaterialList/v1',
            method: 'POST',
            isGetToken: true
        },
        file: {
            path: '/hotelonething/file/',
            method: 'POST',
            server: 'file',
            isGetToken: true
        },
        // 查询事项材料梳理信息
        getMaterialList: {
            path: '/sds/taskCenter/getMaterialList/v1',
            method: 'POST',
            isGetToken: true
        },
        eformToWordOrPdf: {
            path: '/sds/epointsform/eformToWordOrPdf',
            method: 'POST',
            isGetToken: true,
        },
        insertFormSeal: {
            path: '/sds/zwztsfromrest/insertFormSeal',
            method: 'POST',
            isGetToken: true,
        },
        isSealed: {
            path: '/sds/zwztsfromrest/isSealed',
            method: 'POST',
            isGetToken: true,
        },
        getQmResultUrl: {
            path: '/sds/zwztsfromrest/getQmResultUrl',
            method: 'POST',
            isGetToken: true,
        }


    },
}


// WEBPACK FOOTER //
// ./src/conf/api/common.js